import {
	MouseEvent,
	ReactElement,
	useContext
} from "react";
import { generateMaintenanceMessage } from "../useTileTooltip";
import { Icon } from "client/Components";
import {
	AlertManager,
	useAlerts,
	useUserTimezone
} from "client/Hooks";
import { InteractionState, TileContext } from "./TileContext";
import { TimeZone } from "client/DateAndTime/timezones";
import styles from "./TileStatus.module.less";
import classNames from "classnames";

export const TileStatus = (): ReactElement | null => {
	const {
		interactionState,
		appIsLicensed,
		appIsNotAccessible,
		conditionalAccess,
		maintenanceWindow
	} = useContext(TileContext);

	const alertManager: AlertManager = useAlerts();
	const userTimezone: TimeZone = useUserTimezone();

	if (appIsNotAccessible || !appIsLicensed) {
		return (
			<span className={styles.root}>
				<Icon value="eye-slash" />
			</span>
		);
	}

	if (conditionalAccess) {
		return (
			<span
				className={
					classNames(
						styles.root,
						styles.root_danger
					)
				}
				title={conditionalAccess.reason}
				onClick={(ev: MouseEvent) => {
					ev.stopPropagation();
					alertManager.showInfo(conditionalAccess.reason);
				}}
			>
				<Icon value={conditionalAccess.hideTile ? "eye-slash" : "ban"} />
			</span>
		);
	}

	if (maintenanceWindow && interactionState === InteractionState.Default) {
		const tooltip: string = generateMaintenanceMessage(
			"app",
			maintenanceWindow,
			userTimezone
		);

		return (
			<span
				className={
					classNames(
						styles.root,
						styles.root_danger
					)
				}
				title={tooltip}
				onClick={(ev: MouseEvent) => {
					ev.stopPropagation();
					alertManager.showInfo(tooltip);
				}}
			>
				<Icon value="screwdriver-wrench" />
			</span>
		);
	}

	return null;
};
TileStatus.displayName = "TileStatus";